// import DataObjectBaseClass from './Core';
function SAMAOffenderDissociation(aId) {
    "use strict";
    this.__type = 'SAMAOffenderDissociation:www.veritracks.com';
    this.Id = aId?aId:-1;
    this.SAMAId = '';
    this.AppUserId = gUserDetails.UserId?gUserDetails.UserId:0;
}
SAMAOffenderDissociation.prototype = new DataObjectBaseClass();
SAMAOffenderDissociation.prototype.constructor = SAMAOffenderDissociation;


if (typeof exports !== 'undefined') {
    module.exports = SAMAOffenderDissociation;
}